import {
  DiscountTax,
  TotalTaxExcludingDicountTax,
  TotalTax,
  positive,
  fix2digit,
} from "../../../api/payment/Utilities";
import { calculator } from "./../../../api/services/PriceCalculatorService";
import { calcLoyaltyPoints } from "../../../api/helpers/LoyalityHelper.js";
import { couponCalculator } from "./../../../api/services/CouponCalculatorService";
import {
  findSameItem,
  calcTotalPrice,
} from "../../../api/helpers/shoppingCartHelper";
import { ConvertToShortHandState } from "../../../api/helpers/stringHelper";
import { addressParse } from "../../../api/helpers/doorDashHelper";
import {
  priceTriggerDiscountsSum,
  rollIntoPriceSum,
} from "../../../api/helpers/priceTriggerHelpers";
import { distanceMatrixApi } from "./../../../api/distanceMatrixApi";
import { doorDash } from "./../../../api/doorDashDelveryFeeApi";
import { getDeliveryZone } from "./../../../api/delivery/deliveryService";
import { DateTime, Duration } from "luxon";
import { DetectRolld } from "../../../mixins/detectRolld";
import { writeProductData } from "../../../api/helpers/rtdbHelper";
import store from "../../../store";
export const state = {
  cartItems: [],
  currentstore: null,
  deliveryAddress: null,
  deliveryInstructions: null,
  isDelivery: null,
  isPickup: null,
  coupons: [],
  priceTriggerOutcomes: [],
  forceUpdate: false,
  distance: 0,
  duration: 0,
  doorDashDeliveryFee: 0,
  deliveryAddressMessage: null,
  scheduledDeliveryTime: null,
  userInfo: null,
  selectedCompanyAddress: null,
  showDeliveryFee: false,
  isUpdateDeliverAddress: true,
  cartItemRepository: {},
  subsidyFee: 0,
  lastRequestDateTime: null,
  deliveryIsLoading: false,
  popularStatus: true,
  selectedDeliveryZone: null,
  pointsDiscount: 0,
  redeemptionRuleApplied: false,
  tipCustomAmount: 0,
  tipPercent: 0,
};

export const mutations = {
  setPointsDiscount(state, discount) {
    state.pointsDiscount = discount;
  },
  toggleRedeemptionRule(state, value) {
    if (value != undefined) {
      state.redeemptionRuleApplied = value;
    } else {
      state.redeemptionRuleApplied = !state.redeemptionRuleApplied;
    }
  },
  setPopularStatus(state, popularStatus) {
    state.popularStatus = popularStatus;
  },
  setLastRequestDateTime(state, dateTime) {
    state.lastRequestDateTime = dateTime;
  },
  setDeliveryIsLoading(state, loading) {
    state.deliveryIsLoading = loading;
  },
  setIsDelivery(state, isDelivery) {
    state.isDelivery = isDelivery;
  },
  setIsPickup(state, isPickup) {
    state.isPickup = isPickup;
  },
  setSubsidyFee(state, fee) {
    state.subsidyFee = fee;
  },
  setStore(state, payload) {
    state.currentstore = payload;
  },
  setDeliveryAddress(state, payload) {
    state.deliveryAddress = JSON.parse(JSON.stringify(payload));
  },
  setDeliveryInstructions(state, payload) {
    state.deliveryInstructions = payload;
  },
  setScheduledDeliveryTime(state, payload) {
    state.scheduledDeliveryTime = payload;
  },
  setDoorDashDeliveryFee(state, payload) {
    state.doorDashDeliveryFee = payload;
  },
  setDistance(state, payload) {
    state.distance = payload;
  },
  setDuration(state, payload) {
    state.duration = payload;
  },
  setDeliveryAddressMessage(state, payload) {
    state.deliveryAddressMessage = payload;
  },
  setSelectedCompanyAddress(state, payload) {
    state.selectedCompanyAddress = payload;
  },
  setShowDeliveryFee(state, payload) {
    state.showDeliveryFee = payload;
  },
  setIsUpdateDeliverAddress(state, payload) {
    state.isUpdateDeliverAddress = payload;
  },
  setSelectedDeliveryZone(state, payload) {
    state.selectedDeliveryZone = payload;
  },
  AddCartItemsToRepository(state, payload) {
    state.cartItemRepository[payload.storeId] = {
      cartItems: payload.cartItems,
      currentMenuId: payload.currentMenuId,
    };
  },
  RemoveCartItemsFromRepository(state, payload) {
    state.cartItemRepository[payload.storeId] = null;
  },
  Add_ProductItem(
    state,
    {
      item,
      quantity,
      ProductCategoryIDs,
      ProductTagIDs,
      modifiers,
      PreparationTime,
      sharedcart,
      user,
      table,
      storeId,
    }
  ) {
    let now = new Date();
    const records = state.cartItems.filter((element) => element.id == item.id);
    let same = true;
    let find = null;
    if (records.length > 0) {
      find = findSameItem(item, modifiers, records);
      if (!find) {
        same = false;
      }
    } else {
      same = false;
    }
    if (!same) {
      state.cartItems.push({
        ...item,
        modifiers: modifiers,
        quantity,
        ProductCategoryIDs,
        ProductTagIDs,
        created: now.toUTCString(),
        PreparationTime: PreparationTime,
      });
    } else {
      find.quantity += quantity;
      // if (find.modifiers) {
      //   find.modifiers.map(md => {
      //       md.quantity += modifiers.filter(m => m.ID === md.ID)[0].quantity;
      //   });
      // }

      find.created = new Date().toUTCString();
    }
    if (state.cartItems.length > 0 && sharedcart) {
      writeProductData(user, table, storeId, state.cartItems);
    }
  },
  Set_Items(state, items) {
    if (items) {
      state.cartItems = items;
    }
  },
  REMOVE_CART_ITEM(state, { item, sharedcart, user, table, storeId }) {
    const record = state.cartItems.find(
      (element) => element.uniqueId == item.uniqueId
    );
    state.cartItems.splice(state.cartItems.indexOf(record), 1);
    let rule = store.getters.getFirstValidRedemptionRule;
    if (!rule) {
      state.cartItems = state.cartItems.filter((item) => !item.reedemptionRule);
    }
    if (sharedcart) {
      writeProductData(user, table, storeId, state.cartItems);
    }
  },
  UpdateQuantity(state, { item, quantity, sharedcart, user, table, storeId }) {
    const exceedMaxQuantity = checkSharedMaxQuantity(item, quantity, true);
    if (exceedMaxQuantity) {
      alert(
        `The quantity you selected for this item exceeds the limit of ${store.getters.paylaterSettings.MaximumQuantityLimit}.Please adjust the quantity accordingly to proceed with your order`
      );
      return;
    }
    let records = state.cartItems.filter((element) => element.id == item.id);
    if (records.length == 0) {
      records = state.cartItems.filter((element) => element.id == item.hQID);
    }
    let same = true;
    let find = null;
    if (records.length > 0) {
      find = findSameItem(item, item.modifiers, records, item.uniqueId);
      if (!find) {
        same = false;
      }
      //
      if (same) {
        //let now = new Date();
        find.quantity = quantity;
        //record.created = now.toUTCString();
        if (quantity == 0) {
          state.cartItems.splice(state.cartItems.indexOf(find), 1);
        }
        if (sharedcart) {
          writeProductData(user, table, storeId, state.cartItems);
        }
      }
    }
  },
  add_user_checkout_info(state, userInfo) {
    state.userInfo = userInfo;
  },
  add_coupon_to_Cart(state, coupon) {
    state.coupons = [];
    state.coupons.push(coupon);
  },
  Set_Coupon_Items(state, coupons) {
    state.coupons = coupons;
  },
  Remove_Coupons(state) {
    state.coupons = [];
  },
  remove_coupon_from_Cart(state, couponCode) {
    const record = state.coupons.find(
      (element) => element.CouponCode == couponCode
    );
    state.coupons.splice(state.coupons.indexOf(record), 1);
  },

  setTriggerCheckOutPage(state, paylod) {
    state.TriggerCheckOutPage = paylod;
  },
  setPriceTriggerOutcomes(state, payload) {
    state.priceTriggerOutcomes = payload;
  },
  confirmRollInto(state, payload) {
    var pt = null;
    if (payload.orderId) {
      pt = state.priceTriggerOutcomes.find(
        (pt) => pt.ID == payload.id && pt.order == payload.orderId
      );
    } else {
      pt = state.priceTriggerOutcomes.find((pt) => pt.ID == payload.id);
    }
    if (pt) {
      if (!pt.selectedRollIntos) pt.selectedRollIntos = [];
      pt.selectedRollIntos.push({
        index: pt.selectedRollIntos.length, //use length count as index
        selectedModifiers: payload.modifiers,
        isConfirmed: payload.modifiers.length > 0,
      });
    }
    state.forceUpdate = !state.forceUpdate;
  },
  confirmRollIntos(state, payload) {
    var pt = null;
    if (payload.orderId) {
      pt = state.priceTriggerOutcomes.find(
        (pt) => pt.ID == payload.id && pt.order == payload.orderId
      );
    } else {
      pt = state.priceTriggerOutcomes.find((pt) => pt.ID == payload.id);
    }
    pt.selectedRollIntos = payload.rollIntos.map((s, index) => {
      return {
        index: index,
        selectedModifiers: s.modifiers,
        isConfirmed: s.modifiers.length > 0,
      };
    });
    state.forceUpdate = !state.forceUpdate;
  },

  clearTips(state) {
    state.tipCustomAmount = 0;
    state.tipPercent = 0;
  },
  addTip(state, payload) {
    state.tipPercent = payload;
  },
  addCustomTip(state, payload) {
    state.tipCustomAmount = payload;
  },
};

export const actions = {
  storeCartInStorage: ({ getters }) => {
    localStorage.setItem(
      "stored-cart-items",
      JSON.stringify({
        cartItems: getters.cartItems,
        coupons: getters.coupons,
      })
    );
  },
  loadFromStorage: ({ commit }) => {
    if (localStorage.getItem("stored-cart-items")) {
      var storedData = JSON.parse(localStorage.getItem("stored-cart-items"));
      if (storedData.cartItems && storedData.cartItems.length > 0) {
        commit("Set_Items", storedData.cartItems);
        commit(
          "Set_Coupon_Items",
          storedData.coupons ? storedData.coupons : []
        );
      }
      localStorage.removeItem("stored-cart-items");
    }
  },
  loadCartItemsFromRepository: ({ commit, getters }, storeId) => {
    const storedCartItem = getters.getStoredCartItems(storeId);
    if (
      storedCartItem &&
      storedCartItem.cartItems &&
      storedCartItem.cartItems.length > 0
    ) {
      commit("Set_Items", storedCartItem.cartItems);
      if (storedCartItem.currentMenuId) {
        localStorage.setItem("currentMenuId", storedCartItem.currentMenuId);
      }
    }
  },
  clearCart: ({ commit }) => {
    commit("Set_Items", []);
    commit("Set_Coupon_Items", []);
    commit("setPointsDiscount", 0);
    commit("clearTips");
  },
  resetDistance: ({ commit }) => {
    commit("setDistance", 0);
  },
  clearCoupon: ({ commit }) => {
    commit("Set_Coupon_Items", []);
  },
  addCouponToCart: ({ commit, dispatch }, payload) => {
    commit("add_coupon_to_Cart", payload.coupon);
    dispatch("applyPriceTriggers");
  },
  removeCouponfromCart: ({ commit, dispatch }, coupon) => {
    commit("remove_coupon_from_Cart", coupon);
    dispatch("applyPriceTriggers");
  },
  applyPriceTriggers({ commit, getters }) {
    commit("setPriceTriggerOutcomes", [...getters.getPriceTriggerOutcomes]);
  },
  async applyDeliveryAddress({ commit, getters }, data) {
    try {
      let delivaryAddress = data.address;
      let scheduledTime = data.scheduledTime || getters.getScheduledTime;
      let sTime = new DateTime(new Date(scheduledTime));
      // temporary solution to force doordash return the same estimation for the same day
      sTime = sTime.set({
        hour: 9,
        minute: 30,
      });
      scheduledTime = sTime.toJSDate().toISOString();
      commit("setIsUpdateDeliverAddress", data.isUpdateDeliverAddress);

      if (getters.getIsDelivery) {
        var deliveryOldFullAddress = getters.deliveryAddress
          ? distanceMatrixApi.buildAddress(
              getters.deliveryAddress.StreetAddress,
              getters.deliveryAddress.CityTown,
              getters.deliveryAddress.State,
              getters.deliveryAddress.PostalCode,
              getters.deliveryAddress.Country
            )
          : null;
        var deliveryNewFullAddress = distanceMatrixApi.buildAddress(
          delivaryAddress.StreetAddress,
          delivaryAddress.CityTown,
          delivaryAddress.State,
          delivaryAddress.PostalCode,
          delivaryAddress.Country
        );
        var storeFullAddress = getters.selectedCompany.Location
          ? distanceMatrixApi.buildAddress(
              getters.selectedCompany.Location.Address,
              getters.selectedCompany.Location.Suburb,
              getters.selectedCompany.Location.State,
              getters.selectedCompany.Location.Postcode,
              getters.selectedCompany.Location.Country
            )
          : null;
        //todo
        if (
          !(
            getters.selectedCompany.EnableThirdPartyDelivery &&
            getters.selectedCompany.EnableThirdPartyDelivery.DoorDash
          ) &&
          deliveryOldFullAddress === deliveryNewFullAddress &&
          getters.getSelectedCompanyAddress === storeFullAddress &&
          getters.getDeliveryDistance > 0 &&
          getters.getScheduledTime == scheduledTime
        ) {
          return;
        }
        let requestDateTime = new Date().toISOString();

        commit("setDeliveryAddress", delivaryAddress);
        commit("setScheduledDeliveryTime", scheduledTime);
        commit("setLastRequestDateTime", requestDateTime);
        commit("setDeliveryIsLoading", true);
        var zoneResponse = null;
        if (getters.deliveryAddress.StreetAddress) {
          if (getters.selectedCompany.DeliveryAreaZones) {
            zoneResponse = await getDeliveryZone(
              getters.selectedCompany.ID,
              delivaryAddress.Latitude,
              delivaryAddress.Longitude,
              requestDateTime,
              getters.selectedCompany.TimezoneIanaFormat
            );
            if (
              zoneResponse &&
              zoneResponse.data &&
              zoneResponse.data.Success
            ) {
              commit("setDeliveryAddressMessage", null);
              commit("setSelectedDeliveryZone", zoneResponse.data.Data);
              commit("setSubsidyFee", zoneResponse.data.Data.zoneDeliveryFee);
              commit(
                "setDoorDashDeliveryFee",
                zoneResponse.data.Data.zoneDeliveryFee
              );
            } else {
              commit("setDoorDashDeliveryFee", 0);
              commit("setDuration", 0);
              commit(
                "setDeliveryAddressMessage",
                zoneResponse.data.Status.Message
              );
              commit("setSelectedCompanyAddress", storeFullAddress);
              commit("setSubsidyFee", 0);
              commit("setSelectedDeliveryZone", null);
              commit("setDeliveryIsLoading", false);
              return;
            }
          } else {
            var found = false;
            if (
              getters.selectedCompany.DeliveryAreas &&
              getters.selectedCompany.DeliveryAreas.length > 0
            ) {
              getters.selectedCompany.DeliveryAreas.forEach((item) => {
                var fromPostcode = item.PostcodeFrom;
                var toPostcode = item.PostcodeTo;
                var from = parseInt(fromPostcode);
                var to = parseInt(toPostcode);
                if (
                  parseInt(getters.deliveryAddress.PostalCode) >= from &&
                  parseInt(getters.deliveryAddress.PostalCode) <= to
                ) {
                  found = true;
                }
              });
            } else {
              found = true;
            }

            if (!found) {
              commit("setDoorDashDeliveryFee", 0);
              commit("setDuration", 0);
              commit("setSelectedCompanyAddress", storeFullAddress);
              commit("setSubsidyFee", 0);
              commit("setSelectedDeliveryZone", null);
              commit("setDeliveryIsLoading", false);
              return;
            }
          }

          if (
            getters.selectedCompany.EnableThirdPartyDelivery &&
            getters.selectedCompany.EnableThirdPartyDelivery.DoorDash
          ) {
            var streetAndUnit = addressParse(delivaryAddress.StreetAddress);
            let result = await doorDash(
              getters.getTotalPrice,
              getters.selectedCompany.ID,
              streetAndUnit.street,
              getters.deliveryAddress.CityTown,
              getters.deliveryAddress.State,
              getters.deliveryAddress.PostalCode,
              getters.getScheduledTime
            );
            if (getters.getLastRequestDateTime == requestDateTime) {
              if (result.data.Success) {
                if (
                  !getters.selectedCompany.DeliveryAreaZones ||
                  !zoneResponse ||
                  !zoneResponse.data ||
                  !zoneResponse.data.Success ||
                  (!zoneResponse.data.Data.zoneDeliveryFee &&
                    zoneResponse.data.Data.zoneDeliveryFee !== 0)
                ) {
                  commit("setDoorDashDeliveryFee", result.data.Fee);
                }
                commit("setDuration", result.data.DeliveryDuration);
                commit("setDeliveryAddressMessage", null);
                commit("setSelectedCompanyAddress", storeFullAddress);
                commit("setSubsidyFee", result.data.SubsidyFee);
              } else {
                commit("setDoorDashDeliveryFee", 0);
                commit("setDuration", 0);
                commit("setDeliveryAddressMessage", result.data.Status.Message);
                commit("setSelectedCompanyAddress", storeFullAddress);
                commit("setSubsidyFee", 0);
              }
              commit("setDeliveryIsLoading", false);
            }
          } else {
            let distance = 0;
            let duration = 0;
            let rows = await distanceMatrixApi.byAddress(
              storeFullAddress,
              deliveryNewFullAddress
            );
            if (getters.getLastRequestDateTime == requestDateTime) {
              if (rows) {
                if (rows.elements[0].status == "OK") {
                  distance = Math.ceil(rows.elements[0].distance.value / 1000);
                  duration = Math.round(rows.elements[0].duration.value / 60);
                  //threshold
                  if (distance == 0) distance = 1;
                  commit("setDeliveryAddressMessage", null);
                } else {
                  distance = duration = 0;
                }
                commit("setDistance", distance);
                commit("setDuration", duration);
                commit("setSelectedCompanyAddress", storeFullAddress);
              }
              commit("setDeliveryIsLoading", false);
            }
          }
        } else {
          commit("setDistance", 0);
          commit("setDuration", 0);
          commit("setSelectedCompanyAddress", null);
          commit("setDeliveryIsLoading", false);
        }
      }
    } catch {
      commit("setDeliveryIsLoading", false);
    }
  },
  clearTips: ({ commit }) => {
    commit("clearTips");
  },
  addTip: ({ commit }, tip) => {
    commit("addTip", tip);
  },
  addCustomTip: ({ commit }, tip) => {
    commit("addCustomTip", tip);
  },
  setItems: ({ commit }, payload) => {
    commit("Set_Items", payload);
  },
};

export const getters = {
  pointsDiscount(state) {
    return state.pointsDiscount;
  },
  redemptionDiscount(state, getters) {
    if (getters.getFirstValidRedemptionRule && getters.cartItems.length > 0) {
      if (getters.getFirstValidRedemptionRule.ProductVariant) {
        let find = getters.cartItems.find((item) => item.reedemptionRule);
        if (find) {
          return getters.getFirstValidRedemptionRule.AppliedDiscount;
        }
      } else if (state.redeemptionRuleApplied) {
        return getters.getFirstValidRedemptionRule.AppliedDiscount;
      }
    }
    return 0;
  },
  redeemptionRuleApplied(state) {
    return state.redeemptionRuleApplied;
  },
  checkLocalCartItemsExists: () => {
    try {
      if (localStorage.getItem("stored-cart-items")) {
        var storedData = JSON.parse(localStorage.getItem("stored-cart-items"));
        if (storedData.cartItems && storedData.cartItems.length > 0) {
          return true;
        }
      }
    } catch (ex) {
      //console.log(ex);
    }
    return false;
  },
  getTotalPoints: (state, getters) => {
    var tempTotalPrice = getters.getTotalPrice;
    return calcLoyaltyPoints(getters.applicableLoyalityRule, tempTotalPrice);
  },
  getLastRequestDateTime: (state) => {
    return state.lastRequestDateTime;
  },
  getDeliveryIsLoading: (state) => {
    return state.deliveryIsLoading;
  },
  getPopularStatus: (state) => {
    return state.popularStatus;
  },
  getIsDelivery: (state, getters) => {
    if (!getters.selectedCompanyViewConfig.Delivery) return false;
    return state.isDelivery;
  },
  getIsDoorDashDelivery: (state, getters) => {
    return (
      getters.getIsDelivery &&
      getters.selectedCompany.EnableThirdPartyDelivery &&
      getters.selectedCompany.EnableThirdPartyDelivery.DoorDash
    );
  },
  getIsPickup: (state, getters) => {
    if (!getters.selectedCompanyViewConfig.PickUp) return false;
    return state.isPickup;
  },
  getShowDeliveryFee: (state) => {
    return state.showDeliveryFee;
  },
  getOrderPreparationTime: (state, getters) => {
    var OrderPreparationTime =
      getters.selectedCompany.OrderPreparationTime || 0;
    if (getters.cartItems.length > 0) {
      var item = getters.cartItems.sort((a, b) => {
        return b.PreparationTime - a.PreparationTime;
      })[0];
      return OrderPreparationTime > (item.PreparationTime || 0)
        ? OrderPreparationTime
        : item.PreparationTime;
    }
    return OrderPreparationTime;
  },
  getDeliveryDuration: (state, getters) => {
    if (state.duration > 0 && state.deliveryAddress.StreetAddress) {
      var pt = getters.getOrderPreparationTime || 0;
      var pdb = getters.selectedCompany.OrderPreparationDeliveryBuffer || 0;
      var d = state.duration;
      if (d < 60) d = 60;
      let isdoorDash =
        getters.selectedCompany.EnableThirdPartyDelivery &&
        getters.selectedCompany.EnableThirdPartyDelivery.DoorDash;
      //disable distance matrix for rolld
      if (DetectRolld.methods.isRolldStore() && !isdoorDash) {
        d = 0;
      }
      var dt = Duration.fromMillis((d + (pt + pdb) * 60) * 1000);
      return dt;
    }
    return null;
  },
  getDeliveryPureDuration: (state) => {
    return state.duration;
  },
  getScheduledTime: (state) => {
    return state.scheduledDeliveryTime;
  },
  getSubsidyFee: (state) => {
    return state.subsidyFee;
  },
  getDeliveryDistance: (state) => {
    return state.distance;
  },
  isUpdateDeliverAddress: (state) => {
    return state.isUpdateDeliverAddress;
  },
  getSelectedCompanyAddress: (state) => {
    return state.selectedCompanyAddress;
  },
  getDeliveryAddressMessage: (state) => {
    return state.deliveryAddressMessage;
  },
  deliveryAddress(state) {
    if (state.deliveryAddress)
      return JSON.parse(JSON.stringify(state.deliveryAddress));
    else return {};
  },
  getDeliveryInstructions(state) {
    return state.deliveryInstructions;
  },
  doorDashDeliveryFee(state) {
    return state.doorDashDeliveryFee;
  },
  haveSpecialDeliveryFee: (state, getters) => {
    if (
      getters.selectedCompany &&
      getters.selectedCompany.SpecialDeliveryFees &&
      getters.selectedCompany.SpecialDeliveryFees.length > 0
    ) {
      var filteredSpecialDeliveryFee =
        getters.selectedCompany.SpecialDeliveryFees.filter(function (
          SpecialDeliveryFee
        ) {
          return (
            getters.cartValue - getters.discount >= SpecialDeliveryFee.MinSpend
          );
        });
      if (filteredSpecialDeliveryFee.length > 0) {
        var higher = filteredSpecialDeliveryFee.reduce((a, b) =>
          Number(a.MinSpend) > Number(b.MinSpend) ? a : b
        );
        return higher;
      } else {
        return null;
      }
    }
    return null;
  },
  deliveryFee(state, getters) {
    let _deliveryFee = 0;
    if (
      getters.selectedCompany &&
      getters.selectedCompany.FreightFeeRules &&
      getters.selectedCompany.FreightFeeRules.length > 0
    ) {
      const maxRange =
        getters.selectedCompany.FreightFeeRules[0].PriceRangeMaximum || 0;

      if (
        maxRange &&
        maxRange != 10000 && // default value on backend !
        getters.cartValue >= maxRange
      ) {
        return 0;
      }
    }
    if (
      getters.getIsDelivery &&
      getters.cartItems.filter((p) => !p.disable).length > 0
    ) {
      if (getters.haveSpecialDeliveryFee) {
        _deliveryFee = getters.haveSpecialDeliveryFee.ApplyFee;
      } else {
        if (
          (getters.selectedCompany.EnableThirdPartyDelivery &&
            getters.selectedCompany.EnableThirdPartyDelivery.DoorDash) ||
          getters.selectedCompany.DeliveryAreaZones
        ) {
          _deliveryFee = getters.doorDashDeliveryFee;
        } else {
          var value = getters.cartValue;
          if (getters.selectedCompany.FreightFeeRules) {
            for (
              let i = 0;
              i < getters.selectedCompany.FreightFeeRules.length;
              i++
            ) {
              const rule = getters.selectedCompany.FreightFeeRules[i];
              if (
                (!rule.PriceRangeMinimum || value > rule.PriceRangeMinimum) &&
                (!rule.PriceRangeMaximum || value < rule.PriceRangeMaximum)
              ) {
                _deliveryFee = rule.FreightFeeAmount;
                if (rule.FreightFeePerKilometer && getters.deliveryAddress) {
                  _deliveryFee =
                    _deliveryFee + state.distance * rule.FreightFeePerKilometer;
                }

                if (
                  rule.FreightFeeMinimum &&
                  rule.FreightFeeMinimum > _deliveryFee
                ) {
                  _deliveryFee = rule.FreightFeeMinimum;
                }
                break;
              }
            }
          }
          return _deliveryFee;
        }
      }
    }
    return _deliveryFee;
  },
  addressOutOfService(state, getters) {
    if (
      getters.getIsDelivery &&
      getters.selectedCompany.Location &&
      getters.deliveryAddress &&
      getters.deliveryAddress.State &&
      ConvertToShortHandState(
        getters.selectedCompany.Location.State || ""
      ).toLowerCase() != getters.deliveryAddress.State.toLowerCase()
    ) {
      return true;
    }
    //duration =0 means there is an error on delivery
    if (
      getters.getIsDelivery &&
      state.duration == 0 &&
      getters.deliveryAddress.State &&
      (getters.selectedCompany.DeliveryRadius ||
        (getters.selectedCompany.EnableThirdPartyDelivery &&
          getters.selectedCompany.EnableThirdPartyDelivery.DoorDash) ||
        getters.selectedCompany.DeliveryAreaZones)
    ) {
      return true;
    }
    if (
      getters.getIsDelivery &&
      state.duration > 0 &&
      getters.selectedCompany.DeliveryRadius &&
      getters.selectedCompany.DeliveryRadius > 0
    ) {
      return getters.selectedCompany.DeliveryRadius < state.distance;
    } else {
      return false;
    }
  },
  cartItems: (state, getters) => {
    if (getters.storeSelectionAtCheckoutMode && getters.isInCheckout) {
      if (
        getters.selectedStoreMenus &&
        getters.selectedStoreMenus.length > 0 &&
        getters.selectedStoreMenus[0]
      ) {
        let menu = getters.selectedStoreMenus[0];
        var Products = menu.Products
          ? Object.entries(menu.Products).map((m) => {
              return {
                ...m[1],
                ProductId: parseInt(m[0]),
              };
            })
          : [];
        var Modifiers = menu.ModifierGroups
          ? Object.values(menu.ModifierGroups).flatMap((x) => x.Modifiers)
          : [];
        let newCartItems = state.cartItems.map((p) => {
          var newProduct = Products.filter((f) => f.ProductCode == p.code)[0];
          let result = null;
          if (newProduct == null) {
            result = {
              ...p,
              unavailable: true,
              disable: true,
            };
          } else if (newProduct.Status == 3) {
            result = {
              ...p,
              soldout: true,
              disable: true,
            };
          } else {
            var extraitems = p.modifiers.map((m) => {
              var find = Modifiers.find((f) => f.Code == m.Code);
              if (find && find.Code != null)
                return {
                  ...m,
                  ID: find.ID,
                };
              else
                return {
                  ...m,
                  disable: true,
                };
            });
            result = {
              ...p,
              id: newProduct.ProductId,
              modifiers: extraitems,
              hQID: p.id,
            };
          }
          return result;
        });
        return newCartItems;
      } else {
        // disable all cartItems
        return state.cartItems.map((p) => {
          return {
            ...p,
            unavailable: true,
            disable: true,
          };
        });
      }
    } else {
      let copy = [...state.cartItems];
      return copy.sort((a, b) => {
        return new Date(b.created) - new Date(a.created);
      });
    }
  },
  costlyCartItems: (state, getters) => {
    let copy = [
      ...getters.cartItems.filter((p) => !p.disable && !p.reedemptionRule),
    ];
    return copy.sort((a, b) => {
      return new Date(b.created) - new Date(a.created);
    });
  },
  cartTotalQuantity: (state, getters) => {
    let copy = [...getters.cartItems.filter((p) => !p.disable)];
    let totalQuantity = 0;
    copy.forEach((element) => {
      totalQuantity += Number(element.quantity);
    });
    return totalQuantity;
  },
  cartValue: (state, getters) => {
    let res = 0;
    res = calculator.calcCartPrice(getters.cartItems.filter((p) => !p.disable));
    var rollintoSum = rollIntoPriceSum(state.priceTriggerOutcomes);
    return positive(res + rollintoSum + 0);
  },
  productsValue: (state) => (products) => {
    let res = 0;
    if (!products) return res;
    res = calculator.calcCartPrice(products.filter((p) => !p.disable));
    const rollintoSum = rollIntoPriceSum(state.priceTriggerOutcomes);
    return positive(res + rollintoSum + 0);
  },
  reedemptionValue: (state, getters) => {
    var value = calculator.calcCartPrice(
      getters.cartItems.filter((p) => !p.disable && p.reedemptionRule)
    );
    return value;
  },
  reedemptionLocalUsedPoints: (state, getters) => {
    var points = 0;
    getters.cartItems
      .filter((p) => !p.disable && p.reedemptionRule)
      .forEach((cartItem) => {
        points += cartItem.reedemptionRule.Point;
      });
    return points;
  },
  reedemptionPoints: (state, getters) => {
    if (getters.dbuser && getters.dbuser.RewardPoints)
      return getters.dbuser.RewardPoints;
    else return 0;
  },
  getredemptionRewardPoints: (state, getters) => {
    var points = 0;
    getters.cartItems
      .filter((p) => !p.disable && !p.reedemptionRule)
      .forEach((cartItem) => {
        points += cartItem.RewardPoint * cartItem.quantity;
      });
    return points;
  },
  currentstore(state) {
    return state.currentstore;
  },

  totaltaxExcludingDicountTax(state, getters) {
    return positive(
      TotalTaxExcludingDicountTax(getters.cartItems.filter((p) => !p.disable))
    );
  },
  totaltax(state, getters) {
    return positive(
      TotalTax(
        getters.cartItems.filter((p) => !p.disable),
        getters.cartValue,
        getters.discount,
        getters.getSurchargeHolidayValidGST + getters.getBankSurchargeValidGST
      )
    );
  },
  totalGst(state, getters) {
    return fix2digit(getters.cartValue ? getters.cartValue / 11 : 0);
  },
  // subTotalTax(state, getters) {
  //   return positive(
  //     SubTotalTax(
  //       getters.cartItems.filter((p) => !p.disable),
  //       getters.getSurchargeHolidayValidTax
  //     )
  //   );
  // },
  discountTax(state, getters) {
    return positive(
      DiscountTax(
        TotalTaxExcludingDicountTax(
          getters.cartItems.filter((p) => !p.disable)
        ),
        getters.cartValue,
        getters.discount
      )
    );
  },
  discountExcludingTax(state, getters) {
    return positive(getters.discount - getters.discountTax);
  },
  couponDiscount(state, getters) {
    const rollintoSum = rollIntoPriceSum(state.priceTriggerOutcomes);
    return couponCalculator.calcAllCoupons(
      state.coupons,
      getters.cartItems.filter((p) => !p.disable),
      rollintoSum
    );
  },
  discount(state, getters) {
    const discountResult =
      getters.couponDiscount +
      priceTriggerDiscountsSum(getters.getPriceTriggerOutcomes) +
      0 +
      state.pointsDiscount +
      getters.redemptionDiscount +
      getters.stampsDiscount;

    const cartValue = getters.cartValue;
    return discountResult > cartValue ? cartValue : discountResult;
  },

  used_coupons: (state, getters) => {
    couponCalculator.calcAllCoupons(
      state.coupons,
      getters.cartItems.filter((p) => !p.disable)
    );
    return couponCalculator.used_Coupons;
  },
  getTotalPrice(state, getters) {
    let totalTipValue = 0;
    const total =
      calcTotalPrice(getters.cartValue, getters.deliveryFee, getters.discount) +
      getters.getSurchargeAmount;

    //custom tip amount overrides tip percent
    const customTipAmount = getters.getTipCustomAmount;
    const tipPercent = getters.getTipPercent;
    totalTipValue = customTipAmount
      ? customTipAmount
      : (Number(total) / 100) * tipPercent;
    totalTipValue = totalTipValue > 0 ? totalTipValue : 0;
    return total + totalTipValue;
  },
  getTipAmount(state, getters) {
    const customTipAmount = getters.getTipCustomAmount;
    const total =
      calcTotalPrice(getters.cartValue, getters.deliveryFee, getters.discount) +
      getters.getSurchargeAmount;
    const tipPercent = getters.getTipPercent;
    return customTipAmount
      ? customTipAmount
      : (Number(total) / 100) * tipPercent;

  },
  getTotalPriceWithoutTips(state, getters) {
    return (
      calcTotalPrice(getters.cartValue, getters.deliveryFee, getters.discount) +
      getters.getSurchargeAmount
    );
  },
  getTotalPriceWithoutTipsSurcharge(state, getters) {
    return calcTotalPrice(
      getters.cartValue,
      getters.deliveryFee,
      getters.discount
    );
  },

  priceTriggerOutcomes(state) {
    return state.priceTriggerOutcomes;
  },
  coupons: (state) => {
    return state.coupons;
  },
  userCheckoutInfo: (state) => {
    return state.userInfo;
  },
  getStoredCartItems: (state) => (storeId) => {
    return state.cartItemRepository[storeId];
  },
  getSelectedDeliveryZone: (state) => {
    return state.selectedDeliveryZone;
  },
  getTipPercent: (state) => {
    return state.tipPercent;
  },
  getTipCustomAmount: (state) => {
    return state.tipCustomAmount;
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
export function checkSharedMaxQuantity(item, quantity, update = false) {
  const cartItem = store.getters.cartItems.find((it) => it.id == item.id);
  let q = quantity;
  if (cartItem && !update) {
    q += cartItem.quantity;
  }
  const sharedMaxQuantity = store.getters.paylaterSettings.MaximumQuantityLimit;
  const payLaterEnabled = store.getters.paylaterSettings.Enabled;
  return (
    payLaterEnabled &&
    sharedMaxQuantity > 0 &&
    item.IsMaxQuantityLevelEnabled &&
    q > sharedMaxQuantity
  );
}
